const routes = [
  {
    path: 'downtime-log',
    component: () => import(/* webpackChunkName: "downtime-log" */ './views/Index.vue'),
    meta: {
      permissionRequired: true,
    },
    children: [
      {
        path: '',
        name: 'downtimeLog',
        component: () => import(/* webpackChunkName: "downtime-log" */ './views/DowntimeLog.vue'),
      },
      {
        path: 'settings/:id?',
        name: 'downtimeLogSettings',
        component:
        () => import(/* webpackChunkName: "downtime-log" */ './views/DowntimeLogSettings.vue'),
      },
    ],
  },
];

export default routes;
